 <template>
 <SmallSquare content='智能营销礼品订单记录的是”智能营销“应用中参与扫码领奖的消费者实物中奖信息，您可以在此对中奖用户订单进行发货、核对等操作。' :padding='true'></SmallSquare>
  <a-card :bordered='false'>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane key="1" tab="快递发货">
        <express></express>
      </a-tab-pane>
      <a-tab-pane key="2" tab="到店核销">
        <toStore></toStore>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { reactive, toRefs } from "vue";
import express from './components/express';
import toStore from './components/toStore';
export default {
  components: {express,toStore },
  setup(props) {
    const state = reactive({
      activeKey:'1'
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>